import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MLO AND UNDERWRITING COMMISSION")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, " % ", -1)

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnderwritingCommission',
  props: {
data: {
  type: Object,
  defaul: null,
},
},
  setup(__props) {

const props = __props;


const { data } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).mlo_commission) = $event))
            }, null, 512), [
              [_vModelText, _unref(data).mlo_commission]
            ])
          ]),
          _hoisted_3
        ])
      ])
    ])
  ]))
}
}

})